import { Button, Divider } from "@mui/material";
import { useTheme } from "../../../components/hooks/useTheme";
import useAuth from "../../../components/hooks/useAuth";
import { useEffect, useState } from "react";
import AddPayments from "./AddPayments2";
import AddRefund from "./AddRefund2";
import AddDiscount from "./AddDiscount2";
import AddAdjustmentModal from "../../../components/common/AddAdjustmentModal2";
import colorConfigs from "../../../configs/colorConfigs";
import AdjustmentList from "../../../components/common/AdjustmentList2";
import { openReservation, updateStatus } from "../../../services/rental";
import useConfirm from "../../../components/hooks/useConfirm";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import CancelReservationPopup from "./CancelReservationPopup";


type PaymentsProps = {
  formattedCreatedAt: string;
  allPaymentList: any[];
  refreshThepayment: () => void;
  allPaymentRequestList: any[];
  refreshThePaymentRequest: () => void;
  refundList: any[];
  refreshThRefund: () => void;
  discountOptions: any[];
  appliedDiscountList: any[];
  securityDepositAmount: number;
  extraValue: any[];
  isCompletedOrCancelled: boolean;
  getDataFromExtras: (extraValue: any[]) => void;
  refreshTheAdjustment: () => void;
  reservationId: number;
  preferredDateFormat: string;
  creditCardList: any[];
  reservationAdditionalCharge: any[];
  summaryData: any;
  refreshTheSummary: () => void;
  setPleaseWait: (value: boolean) => void;
};

export const Payments = ({
  formattedCreatedAt,
  allPaymentList,
  refreshThepayment,
  allPaymentRequestList,
  refreshThePaymentRequest,
  refundList,
  refreshThRefund,
  discountOptions,
  appliedDiscountList,
  securityDepositAmount,
  extraValue,
  isCompletedOrCancelled,
  getDataFromExtras,
  refreshTheAdjustment,
  reservationId,
  preferredDateFormat,
  creditCardList,
  reservationAdditionalCharge,
  summaryData,
  refreshTheSummary,
  setPleaseWait
}: PaymentsProps) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const [isAddAdjustment, setIsAddAdjustment] = useState<boolean>(false);
  const [hideTheQuoteButton, setHideTheQuoteButton] = useState<boolean>(false);
  const [isSecurityDepositedPaid, setIsSecurityDepositedPaid] = useState<boolean>(false);
  const [isSecurityDepositedRefunded, setIsSecurityDepositedRefunded] = useState<boolean>(false);
  const [showAllTheButtonBeforeRental, setShowAllTheButtonBeforeRental] = useState<boolean>(true);
  const [openCancelPopup, setOpenCancelPopup] = useState<boolean>(false);

  useEffect(() => {
    if (summaryData?.securityDepositPaid || summaryData?.totalPaid > 0) {
      setHideTheQuoteButton(true);
    } else {
      setHideTheQuoteButton(summaryData?.status?.toLowerCase() === "quotes");
    }

    setIsSecurityDepositedPaid(summaryData?.securityDepositPaid);
    setIsSecurityDepositedRefunded(summaryData?.securityDepositRefunded);

    if (
      summaryData?.status?.toLowerCase() === "rental"
      || summaryData?.status?.toLowerCase() === "completed"
      || summaryData?.status?.toLowerCase() === "overdue"
      || summaryData?.status?.toLowerCase() === "reopen"
    ) {
      setShowAllTheButtonBeforeRental(false);
    } else {
      setShowAllTheButtonBeforeRental(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summaryData])

  const changeStatusToQuote = () => {
    if (hideTheQuoteButton) {
      return;
    }

    if (!isCompletedOrCancelled) {
      setConfirmData({
        title: 'Confirm Quotes',
        summary: "Are you sure you want to change status to Quotes?",
        confirmBtn: 'Yes',
        isConfirm: async (callback: any) => {
          setPleaseWait(true);

          updateStatus(
            reservationId,
            "Quotes",
            auth?.id,
            tenantId
          )
            .then(() => {
              refreshTheSummary();
              handleTenantError(null);
            })
            .catch((error) => {
              setPleaseWait(false);
              handleTenantError(error);
            });

          callback();
        }
      });

      setConfirmPopup(true);
    }
  };

  const changeStatusToPending = () => {
    if (!isCompletedOrCancelled) {
      setConfirmData({
        title: 'Confirm Pending',
        summary: "Are you sure you want to change status to Pending?",
        confirmBtn: 'Yes',
        isConfirm: async (callback: any) => {
          setPleaseWait(true);

          updateStatus(
            reservationId,
            "Pending",
            auth?.id,
            tenantId
          )
            .then(() => {
              refreshTheSummary();
              handleTenantError(null);
            })
            .catch((error) => {
              setPleaseWait(false);
              handleTenantError(error);
            });

          callback();
        }
      });

      setConfirmPopup(true);
    }
  };

  const changeStatusToOpen = () => {
    if (!isCompletedOrCancelled || summaryData?.status === "Cancelled" || summaryData?.status === "Cancelled Paid") {
      setConfirmData({
        title: 'Confirm Open',
        summary: "Are you sure you want to change status to Open?",
        confirmBtn: 'Yes',
        isConfirm: async (callback: any) => {
          setPleaseWait(true);

          openReservation(
            reservationId,
            auth?.id,
            tenantId
          )
            .then(() => {
              refreshTheSummary();
              handleTenantError(null);
            })
            .catch((error) => {
              setPleaseWait(false);
              handleTenantError(error);
            });

          callback();
        }
      });

      setConfirmPopup(true);
    }
  };

  const changeStatusToCancel = () => {
    if (!isCompletedOrCancelled) {
      setOpenCancelPopup(true);
    }
  };

  const changeStatusToNoShow = () => {
    if (!isCompletedOrCancelled) {
      setConfirmData({
        title: 'Confirm No Show',
        summary: "Are you sure you want to change status to No Show?",
        confirmBtn: 'Yes',
        isConfirm: async (callback: any) => {
          setPleaseWait(true);

          updateStatus(
            reservationId,
            "No Show",
            auth?.id,
            tenantId
          )
            .then(() => {
              refreshTheSummary();
              handleTenantError(null);
            })
            .catch((error) => {
              setPleaseWait(false);
              handleTenantError(error);
            });

          callback();
        }
      });

      setConfirmPopup(true);
    }
  };


  return (
    <>
      <div className="w-full">
        <AddPayments
          formattedCreatedAt={formattedCreatedAt}
          allPaymentList={allPaymentList}
          allPaymentRequestList={allPaymentRequestList}
          securityDepositAmount={securityDepositAmount}
          isCompletedOrCancelled={isCompletedOrCancelled}
          reservationId={reservationId}
          refundList={refundList}
          preferredDateFormat={preferredDateFormat}
          isSecurityDepositedPaid={isSecurityDepositedPaid}
          isSecurityDepositedRefunded={isSecurityDepositedRefunded}
          creditCardList={creditCardList}
          summaryData={summaryData}
          refreshTheSummary={refreshTheSummary}
          refreshThepayment={refreshThepayment}
          refreshThePaymentRequest={refreshThePaymentRequest}
          refreshThRefund={refreshThRefund}
          setPleaseWait={setPleaseWait}
        />

        <AddRefund
          summaryData={summaryData}
          formattedCreatedAt={formattedCreatedAt}
          refreshTheSummary={refreshTheSummary}
          refundList={refundList}
          refreshThRefund={refreshThRefund}
          isCompletedOrCancelled={isCompletedOrCancelled}
          setPleaseWait={setPleaseWait}
          reservationId={reservationId}
          preferredDateFormat={preferredDateFormat}
        />

        <AddDiscount
          refreshTheSummary={refreshTheSummary}
          formattedCreatedAt={formattedCreatedAt}
          discountOptions={discountOptions}
          appliedDiscountList={appliedDiscountList}
          isCompletedOrCancelled={isCompletedOrCancelled}
          setPleaseWait={setPleaseWait}
          reservationId={reservationId}
          summaryData={summaryData}
        />

        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <div className="w-full flex items-center gap-2.5 mt-4">
          {
            showAllTheButtonBeforeRental && (
              <>
                {
                  !hideTheQuoteButton && (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: "#006A71",
                        fontSize: "10px"
                      }}
                      onClick={() => changeStatusToQuote()}
                    >
                      Change to Quote
                    </Button>
                  )
                }

                {
                  summaryData?.status === "Open" ? (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: "#673128",
                        fontSize: "10px"
                      }}
                      onClick={() => changeStatusToPending()}
                    >
                      Pending Reservation
                    </Button>
                  ) : (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: "#DE6F0D",
                        fontSize: "10px"
                      }}
                      onClick={() => changeStatusToOpen()}
                    >
                      Change to Open
                    </Button>
                  )
                }

                {
                  (summaryData?.status !== "Cancelled" && summaryData?.status !== "Cancelled Paid") && (

                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.delete.bg,
                        fontSize: "10px"
                      }}
                      onClick={() => changeStatusToCancel()}
                    >
                      Cancel Reservation
                    </Button>
                  )
                }

                {
                  summaryData?.status !== "No Show" && (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: "#DE6F0D",
                        fontSize: "10px"
                      }}
                      onClick={() => changeStatusToNoShow()}
                    >
                      No Show
                    </Button>
                  )
                }
              </>
            )
          }

          <Button variant="contained"
            sx={{
              backgroundColor: "#F38C79",
              fontSize: "10px"
            }}
            onClick={() => {
              if (!isCompletedOrCancelled)
                setIsAddAdjustment(true)
            }}
          >
            Add Charge or Adjustment
          </Button>
        </div>

        {
          reservationAdditionalCharge?.length > 0 && (
            <div className="w-full mt-[1.5rem] mb-2">
              <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                Adjustments
              </span>

              <Divider className={`w-full ${themeStyles.divider.bg}`} />

              <AdjustmentList
                adjustmentData={reservationAdditionalCharge}
                extraValue={extraValue}
                summaryData={summaryData}
                isCompletedOrCancelled={isCompletedOrCancelled}
                refreshTheSummary={() => {
                  refreshTheSummary();
                  refreshTheAdjustment();
                }}
                reservationId={reservationId}
                setPleaseWait={setPleaseWait}
              />
            </div>
          )
        }
      </div>

      <AddAdjustmentModal
        adjustmentIsOpen={isAddAdjustment}
        setAdjustmentIsOpen={setIsAddAdjustment}
        extraValue={extraValue}
        isCompletedOrCancelled={isCompletedOrCancelled}
        getDataFromExtras={getDataFromExtras}
        refreshTheSummary={() => {
          refreshTheSummary();
          refreshTheAdjustment();
        }}
        reservationId={reservationId}
        setPleaseWait={setPleaseWait}
      />

      <CancelReservationPopup
        open={openCancelPopup}
        onClose={() => setOpenCancelPopup(false)}
        preferredDateFormat={preferredDateFormat}
        reservationId={reservationId}
        summaryData={summaryData}
        refreshTheReservation={refreshTheSummary}
        setPleaseWait={setPleaseWait}
      />
    </>
  )
}